import React from 'react';
import PropTypes from 'prop-types';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import DatePicker from 'react-datepicker';
import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';

import 'react-datepicker/dist/react-datepicker.css';
import './index.css';

const DateFilter = ({selectedDate, setSelectedDate, name, buttonVariant="link"}) => {
  const [ t ] = useTranslation();

  const datePicker = (date, limitDate, limit) => {
    return (
      <div>
        {t(`dates.${date}`)}
        <DatePicker
          selected={selectedDate[date]}
          onChange={d => setSelectedDate({...selectedDate, [date]: d})}
          dateFormat="yyyy-MM-dd"
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...{[limit]: selectedDate[limitDate]}}
          showMonthDropdown
          showYearDropdown
        />
      </div>
    )
  };

  return (
    <OverlayTrigger
      rootClose
      trigger='click'
      key='bottom'
      placement='bottom'
      overlay={
        <Popover id="popover-positioned-bottom">
          <Popover.Content>
            <>
              <Button
                className="button-clear"
                variant="link"
                onClick={e => {
                  e.preventDefault();
                  setSelectedDate({startDate: '', endDate: ''});
                }}
              >
                {t('multiselect.clear')}
              </Button>
              {datePicker('startDate', 'endDate', 'maxDate')}
              {datePicker('endDate', 'startDate', 'minDate')}
            </>
          </Popover.Content>
        </Popover>
      }
    >
      <Button variant={buttonVariant}>{name}</Button>
    </OverlayTrigger>
  )
};

DateFilter.propTypes = {
  selectedDate: PropTypes.object.isRequired,
  setSelectedDate: PropTypes.func,
  name: PropTypes.string,
  buttonVariant: PropTypes.string,
};


export default DateFilter;
